import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

export const PasswordField = ({ field, register, errors, theme }) => {
  const [showPassword, setShowPassword] = useState(false);
  
  return (
    <div className="relative">
      <input
        id={field.id}
        type={showPassword ? 'text' : 'password'}
        {...register(field.id, field.validation)}
        placeholder={field.placeholder}
        className={`${theme.input} pr-10 ${errors[field.id] ? theme.inputError : ''}`}
        disabled={field.disabled}
        autoComplete={field.autoComplete || 'current-password'}
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
      >
        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
      </button>
    </div>
  );
};